import moment from 'moment'

export const expiryDate = (dateInput) => {
  var expiration = moment(dateInput).format('YYYY-MM-DD')
  var current_date = moment().format('YYYY-MM-DD')
  var days = moment(expiration).diff(current_date, 'days')
  return days
}
